import i18n from "locales/i18n";
import { enumLevelTrd } from "./enums";

/**
 * Returns the translated title for a specific classification level based on the provided level enum.
 * @param {enumLevelTrd} level - The classification level enum to determine the appropriate translation.
 * @returns {string} - The translated string for the provided classification level, or an empty string if the level is not recognized.
 * Possible values for `level`:
 * - `enumLevelTrd.BACKGROUND` - Returns the translation for the background level.
 * - `enumLevelTrd.SECTION` - Returns the translation for the section level.
 * - `enumLevelTrd.SUBSECTION` - Returns the translation for the subsection level.
 * - `enumLevelTrd.SERIE` - Returns the translation for the series level.
 * - `enumLevelTrd.SUBSERIE` - Returns the translation for the subseries level.
 * - `enumLevelTrd.EXPEDIENT` - Returns the translation for the expedient level.
 * - `enumLevelTrd.SUBDIVISION` - Returns the translation for the subdivision level.
 * - `enumLevelTrd.DIRECTORY` - Returns the translation for the directory level.
 * - If `level` does not match any case, returns an empty string.
 */
export const levelClassificationTrd = (level) => {
  switch (level) {
    case enumLevelTrd.BACKGROUND:
      return i18n.t("trd.formTittle9");

    case enumLevelTrd.SECTION:
      return i18n.t("trd.formTittle10");

    case enumLevelTrd.SUBSECTION:
      return i18n.t("trd.formTittle11");

    case enumLevelTrd.SERIE:
      return i18n.t("trd.formTittle12");

    case enumLevelTrd.SUBSERIE:
      return i18n.t("trd.formTittle13");

    case enumLevelTrd.EXPEDIENT:
      return i18n.t("trd.formTittle14");

    case enumLevelTrd.SUBDIVISION:
      return i18n.t("trd.formTittle16");

    case enumLevelTrd.DIRECTORY:
      return i18n.t("trd.formTittle32.2");

    default:
      return "";
  }
};
